
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  display: inline-block;
}

.status-indicator-wrapper {
  display: flex;
  align-items: center;
  font-family: var(--slh-default-font-family, "Open Sans");
  font-style: normal;
  font-weight: 400;
  font-size: var(--slh-base-xs-font-size, 14px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
.status-indicator-wrapper .status-indicator {
  width: 8px;
  height: 8px;
  display: block;
  border-radius: 8px;
  margin-right: 8px;
  background-color: #A8B3C2;
}
.status-indicator-wrapper .status-indicator.success {
  background-color: #60B34A;
}
.status-indicator-wrapper .status-indicator.info {
  background-color: #3B87D4;
}
.status-indicator-wrapper .status-indicator.warning {
  background-color: #F5A83D;
}
.status-indicator-wrapper .status-indicator.error {
  background-color: #DD5350;
}
`;
